/**
 * Etwas erst tun, wenn eine Weile Ruhe war.
 *
 * Jeder Auslöser setzt die Uhr zurück. Eine Sammeländerung an 386 Plätzen
 * führt damit zu einem Durchgang, nicht zu 386.
 *
 * Die Uhr wird hereingereicht, damit Tests nicht dreissig Sekunden warten.
 */
export function verzoegere(tun, ms = 30000, uhr = globalThis) {
  let laufend = null;

  return {
    ausloesen() {
      if (laufend !== null) uhr.clearTimeout(laufend);
      laufend = uhr.setTimeout(() => { laufend = null; tun(); }, ms);
    },
    abbrechen() {
      if (laufend !== null) uhr.clearTimeout(laufend);
      laufend = null;
    },
  };
}
